"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const IconLike_1 = __importDefault(require("../../assets/icons/IconLike"));
const IconLiked_1 = __importDefault(require("../../assets/icons/IconLiked"));
const Home_1 = __importDefault(require("../../networking/apis/Home"));
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const Iconlike = (props) => {
    const { numberLikes, idPost, height = (0, scale_1.scale)(18), data, disabled = false } = props || 0;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [value, setValue] = react_1.default.useState(props.checked || false);
    const [countLikes, setCountLikes] = (0, react_1.useState)(numberLikes || 0);
    // const [check, setCheck] = useState<boolean>(false)
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const isAnonymous = dataUser?.registration_status == 0;
    const datarRef = (0, react_1.useRef)(false);
    const refIsCallingApi = (0, react_1.useRef)(false);
    const dataNumberLike = (0, react_1.useRef)(countLikes);
    (0, react_1.useEffect)(() => {
        dataNumberLike.current = countLikes;
    }, [countLikes]);
    const checkcountLike = (check) => {
        const dataSnapshot = dataNumberLike.current;
        if (check) {
            setCountLikes(+dataSnapshot + 1);
        }
        else {
            setCountLikes(+dataSnapshot - 1);
        }
    };
    (0, react_1.useEffect)(() => {
        let fireStoreSubscribe;
        if (react_native_1.Platform.OS === 'web') {
            if (data?.type != 2) {
                const { firebase } = require('../../../web/firebase/config');
                fireStoreSubscribe = firebase
                    .firestore()
                    .collection('users')
                    .doc(dataUser?.user_id?.toString())
                    .collection('likeTweets')
                    .doc(idPost)
                    .onSnapshot((snapshot) => {
                    if (snapshot.data()) {
                        setValue(true);
                        if (datarRef.current) {
                            checkcountLike(true);
                            // setCountLikes(countLikes + 1)
                            // console.log('countLikes++',countLikes)
                        }
                        // setCheck(true)
                        datarRef.current = true;
                    }
                    else {
                        setValue(false);
                        if (datarRef.current && dataNumberLike.current > 0) {
                            checkcountLike(false);
                        }
                        // setCheck(true)
                        datarRef.current = true;
                    }
                });
            }
        }
        return fireStoreSubscribe;
    }, [idPost]);
    (0, react_1.useEffect)(() => {
        setCountLikes(numberLikes);
    }, [numberLikes]);
    const handleClick = () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingApi.current)
            return;
        if (!value) {
            callApiLike();
        }
        else {
            callApiUnLike();
        }
        if (props.onChange)
            props.onChange();
    };
    const callApiLike = () => {
        refIsCallingApi.current = true;
        Home_1.default.likePost(idPost)
            .then((_res) => {
            const newValue = !value; //switch value
            setValue(newValue);
            // if (callBack && typeof callBack === 'function') {
            //   callBack(1)
            // }
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => (refIsCallingApi.current = false));
    };
    const callApiUnLike = () => {
        refIsCallingApi.current = true;
        Home_1.default.deleteLikePost(idPost)
            .then((_res) => {
            // if (callBack && typeof callBack === 'function') {
            //   callBack(-1)
            // }
            setValue(!value);
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => (refIsCallingApi.current = false));
    };
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
            flexDirection: 'row',
            marginLeft: (0, scale_1.scale)(24),
            alignItems: 'center',
        }, onPress: handleClick, disabled: disabled },
        value ? react_1.default.createElement(IconLiked_1.default, { height: height }) : react_1.default.createElement(IconLike_1.default, { color: '#545454', height: height }),
        !isNaN(numberLikes) && countLikes >= 0 && (react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                fontSize: (0, scale_1.moderateScale)(12),
                lineHeight: (0, scale_1.moderateScale)(18),
                color: value ? '#44A06B' : '#545454',
                marginLeft: (0, scale_1.scale)(8),
                marginRight: (0, scale_1.scale)(24),
            } }, countLikes || 0))));
};
exports.default = Iconlike;
